export default {
	"保存": '保存',
	"内部测试": '内部測試',
	"外部测试": '外部測試',
	'导出': '匯出',
	'导入': '導入',
	'新建一页': '新建一頁',
	'新建一题': '新建一題',
	"全部展开": '全部展開',
	"全部收起": '全部收起',
	"编辑": '編輯',
	"查看帮助": '查看幫助？',
	'确定': '確定',
	'关闭': '關閉',
	'取消': '取消',
	"修改": '修改',
	"提交": '提交',
	"下一页": '下一頁',
	"关闭": '關閉',
	"点击上传": '點擊上傳',
	"新增": '新增',
	"新增选项": '新增選項',
	"新增列问题": '新增列問題',
	"新增行问题": '新增行問題',
	"题库": '題庫',
	"选择分类": '選擇分類',
	"新增问题": '新增問題',
	"是": '是',
	"否": '否',
	"长按开始语音作答": '長按開始語音作答',
	"下一题": '下一題',
  "清除":'清除',
  "点击签名":'點擊簽名',
  "新增分类":'新增分類',
  "下载模板":'下載範本'
}